import { toast } from 'react-toastify';
import { i18n } from '../translate/i18n';
import { isString } from 'lodash';

const toastSuccess = (message) => {
  const msg =
    message.response?.data?.error || message.props.children || String(message);
  if (msg) {
    if (i18n.exists(`backendSuccesss.${msg}`)) {
      toast.success(
        <div
          style={{
            whiteSpace: 'pre-line',
            textAlign: 'center',
            paddingRight: '25px',
          }}
        >
          {i18n.t(`backendSuccesss.${msg}`)}
        </div>,
        {
          toastId: msg,
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'dark',
        },
      );
      return;
    } else {
      toast.success(
        <div
          style={{
            whiteSpace: 'pre-line',
            textAlign: 'center',
            paddingRight: '25px',
          }}
        >
          {msg}
        </div>,
        {
          toastId: msg,
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'dark',
        },
      );
      return;
    }
  }
  if (isString(message)) {
    toast.success(
      <div
        style={{
          whiteSpace: 'pre-line',
          textAlign: 'center',
          paddingRight: '25px',
        }}
      >
        {message}
      </div>,
      {
        toastId: msg,
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'dark',
      },
    );
    return;
  } else {
    toast.success(
      <div
        style={{
          whiteSpace: 'pre-line',
          textAlign: 'center',
          paddingRight: '25px',
        }}
      >
        {'Saved succesfully!'}
      </div>,
      {
        toastId: msg,
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'dark',
      },
    );
    return;
  }
};

export default toastSuccess;
